import React, { useEffect, useRef, useState } from 'react'

import * as signalR from "@microsoft/signalr";

// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import ChatAutoComplete from './ChatAutoComplete';
import { Grid, ListItemButton, Stack, Tooltip, Typography } from '@mui/material';
import Badge, { BadgeProps } from '@mui/material/Badge';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';
import { AiOutlineWechat } from "react-icons/ai";
import { AxiosGet, ResultAPI } from 'service/CommonFunction/TS_function';
import parse from 'html-react-parser';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';


const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        height: '40px',
        width: '40px',
        borderRadius: '50px',
        right: 0,
        border: `2px solid ${theme.palette.background.paper}`,
        backgroundColor: '#d9001b'
    },
}));

const LobbyChat = (props) => {
    // const { closeConnection, joinRoom, users, setsVOCFormID, nChatID, setChatID, setPathImage } = props;
    const { handleLobbyChatJoin, nChatID, users,setPathImage } = props;
    const [connection, setConnection] = useState(null)
    const [selectedIndex, setSelectedIndex] = React.useState(null);
    const [lstLobbyChat, setLstLobbyChat] = React.useState<ILobbyChat[]>([]);
    const [nVOCFormID, setVOCFormID] = React.useState<number>(0);
    const usersRef = useRef(0) as any;
    const isFirstJoinLobby = useRef(true) as any;

    const schema = yup.object().shape({
        sUser: yupFormSchemas.string("User", { required: false }),
        sRoom: yupFormSchemas.string("Room", { required: false }),
    });
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        GetLobbyChat(true);
    }, [])

    useEffect(() => {
        usersRef.current = users;
    }, [users])



    const GetLobbyChat = async (isAutoJoin) => {
        await AxiosGet(`Chat/GetLobbyChat`, { nChatID: nChatID, isAutoJoin: isAutoJoin }, (res) => {
            ResultAPI(res, null, async () => {
                
                setLstLobbyChat(res.lstLobbyChat);
            })
        })


        if (isAutoJoin) {
            JoinLobby();
        }
    }

    const JoinLobby = async () => {
        closeConnection();
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(process.env.REACT_APP_API_URL + "SignalRChat")
            .withAutomaticReconnect()
            .configureLogging(signalR.LogLevel.Information)
            .build();
        setConnection(connection);
        connection.on("SetLobby", (result) => {
        });

        connection.on("ChatLobbyResponse", (result) => {
          
            if (!isFirstJoinLobby.current) {
                if (result.nVOCFormID) {
                    let IshasLobby = lstLobbyChat.filter(f => f.nVOCFormID == result.nVOCFormID);
                    if (IshasLobby) {
                        GetLobbyChat(false);
                    }
                 
                }
            }
            else {
                if (result.sImagePerson) {
                    setPathImage(result.sImagePerson)
                }
                isFirstJoinLobby.current = false;
            }

        });

        connection.onclose(e => {

        });

        await connection.start();

        let param = {
            nFormUser: usersRef.current
        }
        await connection.invoke("JoinLobby", param);
    }

    const closeConnection = async () => {
        try {
            await connection.stop();
        } catch (e) {

        }
    }

    return (
        <FormProvider {...form}>
            <div style={{ backgroundColor: "white", padding: '7px', minHeight: '500px', position: 'relative', border: '1px solid #bdbdbd', borderRadius: '10px' }}>
                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                    <Grid item xs={12}>
                        <Grid container spacing={1} direction="row" justifyContent="start" alignItems="center" style={{ paddingLeft: '1em' }}>
                            <Grid item>
                                <div style={{ backgroundColor: '#cdf4e8', width: '43px', height: '43px', padding: '6px', borderRadius: '50px', border: '1px solid rgb(189, 189, 189)' }}>
                                    <AiOutlineWechat style={{ color: '#11c990', fontSize: '2em' }} />
                                </div>
                            </Grid>
                            <Grid item>
                                {currentLanguage() == "th" ? "ผู้สนทนา" : "Lobby"}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <ChatAutoComplete
                            name="oAutoLobbyChat"
                            sUrlAPI={"Chat/SearchLobbyChat"}
                            ParamUrl={{ "nResponsibleTypeID": form.getValues("sTypeResponPerson") }}
                            label={""}
                            placeholder={currentLanguage() == "th" ? "ค้นหาจากรายชื่อ/เลขที่ใบแจ้ง/เลขที่ใบงาน" : "Enter Name/Report Number/Ticket Number"}
                            // placeholder={"ค้นหาจากรายชื่อ/เลขที่ใบแจ้ง/เลขที่ใบงาน"}
                            required={true}
                            onChange={(e) => {
                                if (e) {
                                    setVOCFormID(e.nVOCFormID)
                                    // setsVOCFormID(e.sVOCFormID)
                                    // setChatID(e.nChatID);
                                    // closeConnection();
                                    // joinRoom(e.nChatID, e.nContactID);
                                    handleLobbyChatJoin(e.sVOCFormID, e.nChatID, e.nContactID, "")
                                }
                                else {
                                    setVOCFormID(0)
                                    // setsVOCFormID(null)
                                    // setChatID(null)
                                    // closeConnection();
                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <div style={{ height: '330px', overflow: 'auto', width: '100%' }}>
                            <List component="nav" sx={{ width: '100%', bgcolor: 'background.paper', padding: '0' }}>
                                {
                                    (nVOCFormID != 0 ? lstLobbyChat.filter(f => f.nVOCFormID == nVOCFormID) : lstLobbyChat).map((item, i) => {
                                        let sTitle = item.sVOCFormCode + "<br>" + item.sContactName;
                                        return (
                                            <div key={i} style={{ backgroundColor: "white", padding: '5px', position: 'relative', border: '1px solid #bdbdbd', borderRadius: '10px', marginBottom: "5px", marginRight: "5px" }}>
                                                <ListItemButton
                                                    selected={nChatID === item.nChatID}
                                                    onClick={(event) => {
                                                        // setPathImage(item.sImagePerson);
                                                        // setChatID(item.nChatID);
                                                        // closeConnection();
                                                        // joinRoom(item.nChatID, item.nContactID);
                                                        // setsVOCFormID(item.sVOCFormID)
                                                        handleLobbyChatJoin(item.sVOCFormID, item.nChatID, item.nContactID, item.sImagePerson)
                                                    }}
                                                >
                                                    <Tooltip title={parse(sTitle)}>
                                                        <ListItem
                                                            secondaryAction={
                                                                item.nNotification != null ?
                                                                    <StyledBadge id={"Notification_" + item.nVOCFormID} color="secondary" badgeContent={item.nNotification} max={99}></StyledBadge>
                                                                    :
                                                                    null
                                                            }
                                                            style={{ minHeight: '50px', padding: '0px' }}
                                                        >
                                                            <ListItemAvatar>
                                                                <Avatar alt="Remy Sharp" src={item.sImagePerson} />
                                                            </ListItemAvatar>
                                                            <ListItemText
                                                                primary={
                                                                    <Grid container >
                                                                        <Grid item xs={12}>
                                                                            <Typography component="div" variant="body2" color="text.primary" style={{
                                                                                textOverflow: "ellipsis",
                                                                                whiteSpace: "nowrap",
                                                                                overflow: "hidden"
                                                                            }}>
                                                                                {item.sVOCFormCode}
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <Typography component="div" variant="body2" color="text.primary" style={{
                                                                                textOverflow: "ellipsis",
                                                                                whiteSpace: "nowrap",
                                                                                overflow: "hidden"
                                                                            }}>
                                                                                {item.sContactName}
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <Typography component="div" style={{
                                                                                textOverflow: "ellipsis",
                                                                                whiteSpace: "nowrap",
                                                                                overflow: "hidden"
                                                                            }}>
                                                                                {item.sLastedMessage}
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <Typography component="div" style={{ fontSize: "0.8rem", textAlign: "right", color: "#8e8d8d" }}>
                                                                                {item.sDateLastChat}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                }
                                                            />
                                                        </ListItem>
                                                    </Tooltip>
                                                </ListItemButton>
                                            </div>
                                        )
                                    })
                                }
                            </List>
                        </div>
                    </Grid>
                </Grid >
            </div >
        </FormProvider >
    )
}

interface ILobbyChat {
    nChatID: number,
    nContactID: number,
    nVOCFormID: number | null,
    sVOCFormCode: string,
    sContactName: string,
    sVOCFormID: string,
    // dLastChat: number,
    sDateLastChat: string,
    nNotification: number | null,
    sImagePerson: string,
    sLastedMessage: string,
}

export default LobbyChat